export const SITE_STATUS = {
  not_installed: { label: 'Not Installed', dot: '#64748b', badge: 'bg-slate-800 text-slate-300 border-slate-600', ring: 'border-slate-700', tint: 'from-slate-800/40' },
  installed: { label: 'Installed', dot: '#2563eb', badge: 'bg-blue-950 text-blue-300 border-blue-600', ring: 'border-blue-600/70', tint: 'from-blue-950/50' },
  inspected_ok: { label: 'Inspected OK', dot: '#10b981', badge: 'bg-emerald-950 text-emerald-300 border-emerald-600', ring: 'border-emerald-600/70', tint: 'from-emerald-950/50' },
  damaged: { label: 'Damaged', dot: '#ef4444', badge: 'bg-rose-950 text-rose-300 border-rose-600', ring: 'border-rose-600/70', tint: 'from-rose-950/50' },
  repair_pending: { label: 'Repair Pending', dot: '#f59e0b', badge: 'bg-amber-950 text-amber-300 border-amber-600', ring: 'border-amber-600/70', tint: 'from-amber-950/50' },
  repaired: { label: 'Repaired', dot: '#06b6d4', badge: 'bg-cyan-950 text-cyan-300 border-cyan-600', ring: 'border-cyan-600/70', tint: 'from-cyan-950/50' },
  replaced: { label: 'Replaced', dot: '#a855f7', badge: 'bg-purple-950 text-purple-300 border-purple-600', ring: 'border-purple-600/70', tint: 'from-purple-950/50' },
};

export const SYNC_STATUS = {
  saved_locally: { label: 'Saved Locally', icon: 'HardDrive', cls: 'bg-slate-800/90 text-slate-300 border-slate-600' },
  queued: { label: 'Queued', icon: 'Clock', cls: 'bg-sky-950/90 text-sky-300 border-sky-600' },
  syncing: { label: 'Syncing', icon: 'RefreshCw', cls: 'bg-purple-950/90 text-purple-300 border-purple-600' },
  synced: { label: 'Synced', icon: 'CheckCircle2', cls: 'bg-emerald-950/90 text-emerald-300 border-emerald-600' },
  failed: { label: 'Failed', icon: 'AlertTriangle', cls: 'bg-rose-950/90 text-rose-300 border-rose-600' },
};

export const POSITIONS = {
  poster_left: 'Poster Left',
  poster_right: 'Poster Right',
  door_vinyl: 'Door Vinyl',
  door_side: 'Door Side',
};

export const ACTIONS = [
  { type: 'install', label: 'Install New', status: 'installed', color: 'bg-blue-600 hover:bg-blue-500', needsCampaign: true },
  { type: 'inspect_ok', label: 'Inspection Passed', status: 'inspected_ok', color: 'bg-emerald-600 hover:bg-emerald-500' },
  { type: 'damage', label: 'Report Damage', status: 'damaged', color: 'bg-rose-600 hover:bg-rose-500' },
  { type: 'needs_repair', label: 'Needs Repair', status: 'repair_pending', color: 'bg-amber-600 hover:bg-amber-500' },
  { type: 'repair', label: 'Log Repair', status: 'repaired', color: 'bg-cyan-600 hover:bg-cyan-500' },
  { type: 'replace', label: 'Mark Replaced', status: 'replaced', color: 'bg-purple-600 hover:bg-purple-500' },
];

export const ROLE_LABELS = {
  admin: 'Admin', manager: 'Manager', operator: 'Operator',
  client: 'Client', society_manager: 'Society Manager', billing: 'Billing',
};

export const ACTION_LABELS = {
  install: 'Installed', inspect_ok: 'Inspected OK', damage: 'Damage Reported',
  needs_repair: 'Repair Needed', repair: 'Repaired', replace: 'Replaced',
};
